import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutPpX = () => (
  <Layout>
    <div className='about3rd'>
      <h1 className='ppTitle'>List of Third-Party SDK</h1>
      <p>Effective Date: 2025-01-20</p>

      <p>
        During the provision of services to users, Huna incorporates various third-party SDK technologies. When interacting with third-party websites or utilizing applications developed by external parties, these entities may use their own cookies or deploy other technical mechanisms. These technologies operate independently of our systems and are not governed by this policy. To maintain your information security, we strongly encourage you to review the privacy policies of any third-party SDK prior to using their services. Should you encounter potential risks with these SDKs or similar tools, we recommend ceasing related activities immediately and contacting us for further assistance.
      </p>

      <p>
        To continuously improve our services, enhance stability, refine quality, and upgrade functionalities, we may adjust the third-party SDKs we utilize and periodically update the SDK directory. In strict compliance with applicable laws, regulations, and oversight requirements, we assess the legality, legitimacy, and necessity of third-party SDKs that process personal information before integrating them, ensuring your data is safeguarded. Detailed data usage and protection practices of third parties can be found via their respective links. Please be aware that third-party SDKs may alter their personal information handling practices due to version updates, policy changes, or other factors. Always refer to their official documentation for the most accurate and updated details.
      </p>

      <h2>Below is a comprehensive list of the third-party SDKs currently implemented:</h2>

      <h3>SDK Name: "Shengwang" SDK</h3>
      <p><strong>Service Provider:</strong> Shanghai Zhaoyan Network Technology Co., Ltd.</p>
      <p><strong>Purpose of Use:</strong> To enable audio and video functionalities.</p>
      <p><strong>Usage Scenario:</strong> Utilized when users engage in audio and video features such as sending voice or video messages.</p>
      <p><strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, MAC address, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, channel information, usage duration, in-channel settings, logs, and transmitted content (text, audio, or other media).</li>
      </ul>
      <p><strong>Client:</strong> Android</p>
      <p><strong>Service Provider Privacy Policy/Official Website Link:</strong> <a href="https://www.shengwang.cn/privacy-policy/" target="_blank" rel="noopener noreferrer">Shengwang Privacy Policy</a></p>

      <h3>SDK Name: Google Pay SDK</h3>
      <p><strong>Service Provider:</strong> Google</p>
      <p><strong>Purpose of Use:</strong> To provide a payment solution using Google Pay.</p>
      <p><strong>Usage Scenario:</strong> Used as a third-party login option on the login page.</p>
      <p><strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.</p>
      <p><strong>Types of Personal Information Collected:</strong> None.</p>
      <p><strong>Client:</strong> Android</p>
      <p><strong>Service Provider Privacy Policy/Official Website Link:</strong> <a href="https://developer.android.google.cn/google/play/billing" target="_blank" rel="noopener noreferrer">Google Play Billing Privacy Policy</a></p>

      <h3>SDK Name: "Tencent Cloud IM" SDK</h3>
      <p><strong>Service Provider:</strong> Tencent Cloud International Pte. Ltd.</p>
      <p><strong>Purpose of Use:</strong> To enable instant messaging functionalities.</p>
      <p><strong>Usage Scenario:</strong> Utilized when users send text, image, or other types of messages.</p>
      <p><strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.</p>
      <p><strong>Types of Personal Information Collected:</strong></p>
      <ul>
        <li>Device Information: Device type, model, CPU information, battery status, operating system details.</li>
        <li>Network Information: IP address, network type.</li>
        <li>Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.</li>
        <li>User Data: User attributes, usage duration, logs, and transmitted content (text, images, or other media).</li>
      </ul>
      <p><strong>Client:</strong> Android</p>
      <p><strong>Service Provider Privacy Policy/Official Website Link:</strong> <a href="https://www.tencentcloud.com/?lang=en&pg=" target="_blank" rel="noopener noreferrer">Tencent Cloud IM Privacy Policy</a></p>

    </div>
  </Layout>
)

export default AboutPpX
